import { NextSeo } from "next-seo";
import Footer from "@/components/shared/Footer";
import { ContentLayout } from "@/components/shared/ContentLayout";
import { HeroSection } from "@/components/shared/HeroSection";

export default function AffiliateTerms() {
  return (
    <div className="space-y-8 overflow-hidden bg-white transition-all duration-200 ease-in-out lg:space-y-12">
      <NextSeo
        title="Crayo AI | Affiliate Terms of Service"
        description="Affiliate Terms of Service for Crayo AI - Your gateway to creating viral TikTok clips in seconds!"
      />
      <HeroSection heading="Affiliate Terms of Service">
        <ContentLayout content={content} />
      </HeroSection>
      <Footer />
    </div>
  );
}

const content = {
  title: "Affiliate Terms of Service",
  description: "Crayo AI Affiliate Program Terms of Service",
  sections: [
    {
      title: "1. Introduction",
      content:
        'Welcome to the Crayo AI Affiliate Program. By signing up for the Crayo AI Affiliate Program ("Program"), you agree to be bound by the following terms and conditions ("Terms of Service"). Please read these terms carefully before participating in the Program.',
    },
    {
      title: "2. Enrollment in the Program",
      content:
        "To begin the enrollment process, you must sign up through the Tolt affiliate program. We may reject your application if we determine, at our sole discretion, that your site is unsuitable for the Program.",
    },
    {
      title: "3. Affiliate Obligations",
      content: "As a member of the Crayo AI Affiliate Program, you agree that:",
      subSections: [
        {
          title: "",
          content: [
            "You will use the Program in a lawful manner and comply with all applicable laws and regulations.",
            "You will not engage in any misleading, fraudulent, or deceptive practices.",
            "You will not engage in the distribution of unsolicited commercial emails (spam).",
            "You will not use Crayo AI's trademarks or other intellectual property without prior written permission, except as provided in the branding guidelines.",
            "You will not use Google Ads, Facebook Ads, TikTok Ads, or any paid social media advertising to promote Crayo.",
          ],
        },
      ],
    },
    {
      title: "4. Approved Promotional Methods",
      content:
        "As a Crayo AI affiliate, you are authorized to promote our products through the following methods:",
      subSections: [
        {
          title: "",
          content: [
            "Website or blog content.",
            "Social media platforms.",
            "Email marketing (in compliance with applicable laws and regulations).",
            "Webinars and online events.",
            "Content marketing, such as articles, reviews, and tutorials.",
          ],
        },
      ],
    },
    {
      title: "5. Prohibited Activities",
      content:
        "The following activities are strictly prohibited and may result in the immediate termination of your account and forfeiture of any accrued commissions:",
      subSections: [
        {
          title: "",
          content: [
            "Using Google Ads or any paid search engine advertising to promote Crayo AI products.",
            "Engaging in any form of advertising that results in misleading or false representations of Crayo AI products.",
            "Impersonating Crayo AI's co-founders (Musa Mustafa and Daniel Bitton) or any other influencers without permission.",
            "Offering any third-party incentives (e.g., rebates, coupons, discounts) to induce sales.",
            "Utilizing cookie stuffing, hidden iframes, or other deceptive practices to generate commissions.",
            "Using unauthorized methods to redirect traffic to the Crayo AI website.",
          ],
        },
      ],
    },
    {
      title: "6. Commission and Payment",
      content: "",
      subSections: [
        {
          title: "Commission Rates:",
          content:
            "Affiliates will earn a commission on qualified sales made through their unique affiliate links. The current commission rate is specified on the Crayo AI affiliate program page.",
        },
        {
          title: "Payment Schedule:",
          content:
            "Commissions are paid on a NET-15 basis, meaning payouts are generated 15 days after the end of the month in which the sale was made. Since payouts are handled manually, affiliates must reach out once a payout is generated to allow us to review the payout.  ",
        },
        {
          title: "Minimum Payout:",
          content:
            "Affiliates must reach a minimum commission balance of $20 before payment is issued. If the minimum balance is not met, earnings will carry over to the next month.",
        },
      ],
    },
    {
      title: "7. Term and Termination",
      content:
        "This Agreement will begin upon our acceptance of your Program application and will continue until terminated by either party. Either you or Crayo AI may terminate this Agreement at any time, with or without cause, by providing written notice to the other party.",
    },
    {
      title: "8. Relationship of Parties",
      content:
        "You and Crayo AI are independent contractors, and nothing in this Agreement will create any partnership, joint venture, agency, franchise, sales representative, or employment relationship between the parties. You have no authority to make or accept any offers or representations on our behalf.",
    },
    {
      title: "9. Limitation of Liability",
      content:
        "Crayo AI will not be liable for any indirect, special, or consequential damages arising in connection with this Agreement or the Program. Our aggregate liability arising with respect to this Agreement and the Program will not exceed the total referral fees paid or payable to you under this Agreement.",
    },
    {
      title: "10. Disclaimers",
      content:
        "Crayo AI makes no express or implied warranties or representations with respect to the Program or any products sold through the Program. In addition, we make no representation that the operation of the Crayo AI website will be uninterrupted or error-free, and we will not be liable for the consequences of any interruptions or errors.",
    },
    {
      title: "11. Modification",
      content:
        "We may modify any of the terms and conditions contained in this Agreement at any time at our sole discretion. Modifications may include, but are not limited to, changes in the payment procedures and Program rules.",
    },
  ],
};
